export const initTypeWriterEffect = (el: HTMLElement, words: string[], pause: number = 1500, typeSpeed: number = 100, deleteSpeed: number = 50) => {
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    const type = () => {
        const currentWord: string = words[wordIndex];

        el.textContent = currentWord.substring(0, charIndex);

        if (!isDeleting && charIndex < currentWord.length) {
            charIndex++;
            setTimeout(type, typeSpeed);
        } else if (isDeleting && charIndex > 0) {
            charIndex--;
            setTimeout(type, deleteSpeed);
        } else if (!isDeleting && charIndex === currentWord.length) {
            isDeleting = true;
            setTimeout(type, pause);
        } else if (isDeleting && charIndex === 0) {
            isDeleting = false;
            wordIndex = (wordIndex + 1) % words.length;
            setTimeout(type, typeSpeed);
        }
    }

    type();
}

